/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : LinkCard.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Card, Grid } from "@mui/material";
import React, { useState } from "react";
import CustomCheckBoxV2 from "../../../components/customComponentsV2/common/checkBox/CustomCheckBoxV2";
import UnlinkLegalDialog from "./UnlinkLegalDialog";
import { otaModuleActionTypes } from "../../../config/appConstants";

function LinkCard({
  rightContent,
  leftContent,
  bottomContent,
  showCheckBox,
  legalReq,
  unlinkLegalRequirement,
  selectValue,
  setSelectValue,
  selectedComponentDetails,
}) {
  const [openUnlinkDialog, setOpenUnlinkDialog] = useState(false);
  const [reason, setReason] = useState("");

  return (
    <Card
      sx={{
        backgroundColor: "white",
        width: "100%",
        height: "250px",
        borderRadius: 0,
      }}
    >
      <Grid container sx={{ width: "100%" }}>
        <Grid item sm={0.5}>
          {showCheckBox && (
            <Box
              sx={{
                pl: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CustomCheckBoxV2
                value={true}
                disabled={
                  selectedComponentDetails?.data?.legal_req_ids?.includes(
                    String(legalReq?.lr_id),
                  ) &&
                  !(
                    selectedComponentDetails?.data?.action_type ===
                    otaModuleActionTypes.LEGAL_LINKING
                  )
                }
                onChange={(e) => {
                  console.log(e.target.checked);
                  if (!e.target.checked) {
                    setOpenUnlinkDialog(true);
                  }
                }}
              />
            </Box>
          )}
        </Grid>

        <Grid item sm={7.5}>
          <Grid container>
            <Grid item sm={12}>
              {rightContent}
            </Grid>
            <Grid item sm={12}>
              {bottomContent}
            </Grid>
          </Grid>
        </Grid>

        <Grid item sm={4}>
          <Box>
            <Box
              sx={{
                display: "flex",
                width: "100%", // important so "end" has space
                cursor: "pointer",

                justifyContent: "end", // aligns content to the right
              }}
            >
              <Box
                sx={{
                  height: "25px",
                  width: "25px",
                  // "&:hover": {
                  //   backgroundColor: "#EBEBEB", // optional hover color
                  //   transform: "scale(1.1)", // optional hover effect
                  // },
                }}
              >
                {/* <ChevronRightIcon sx={{ marginLeft: "auto" }} /> */}
              </Box>
            </Box>
            <Box>{leftContent}</Box>
          </Box>
        </Grid>
      </Grid>

      {/*unlink dialog */}
      {console.log("---UnlinkLegalDialog---", legalReq)}
      <UnlinkLegalDialog
        openDialog={openUnlinkDialog}
        reason={reason}
        setReason={setReason}
        onClose={() => {
          setReason("");
          setOpenUnlinkDialog(false);
        }}
        onSuccess={(reason) => {
          unlinkLegalRequirement({
            reason,
            lr_id: legalReq?.lr_id,
            callback: () => {
              setReason("");
              setOpenUnlinkDialog(false);
            },
          });
        }}
      />
    </Card>
  );
}

export default LinkCard;
